import { useParams } from "react-router-dom";
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container'
import { createNotaSpese, updateNotaSpese } from '../features/notaSpese/notaSpeseSlice'
import { getSharedSchedaSpese, getPersonalSchedaSpese, updateSchedaSpese, setActiveTab} from '../features/schedaSpese/schedaSpeseSlice'
import { getAllCategories } from '../features/categorie/categorieSlice'
import { parseDate } from './utils/dateParser'
import { useEffect } from 'react'
import SelectSearch from './utils/SelectSearch'
import { NotaTipoField } from './shared'


function NotaSpeseForm({ onSuccess, schedaId, notaToEdit = null, beforeDelete = null }) {
  const { id, scope } = useParams();
  const scopeFromUrl = scope === "personal" ? "personal" : "shared";
  const { user } = useSelector((state) => state.auth);
  const { categorie: categories, isLoading: categorieLoading } = useSelector((state) => state.categorie);
  const today = new Date().toISOString().split('T')[0];

  const [formData, setFormData] = useState({
    testo: notaToEdit?.testo ?? '',
    inserimentoData: notaToEdit?.inserimentoData.split('T')[0] ?? today,
    importo: notaToEdit?.importo ?? '',
    categoria: notaToEdit?.categoria || '',
    categoriaToShow: '',
    tipo: notaToEdit?.tipo === 'entrata' ? 'entrata' : 'spesa'
  })
  const [isDisabled, setisDisabled] = useState(false);
  const { testo, inserimentoData, importo, categoria, categoriaToShow, tipo } = formData

  const dispatch = useDispatch()

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  useEffect(() => {
    dispatch(setActiveTab(scopeFromUrl));
  }, [scopeFromUrl, dispatch]);

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!testo || !importo) {
      toast.error('Please fill in all required fields')
    } else {
      if (parseFloat(importo) > 10000) { return toast.error('Limit amount 10000') }

      const notaSpeseData = {
        testo,
        inserimentoData: inserimentoData || new Date().toISOString(),
        importo: parseFloat(importo),
        categoria: categoria,
        tipo,
        inserimentoUser: {
          id: user._id,
          email: user.email,
          name: user.name
        }
      };

      if (notaToEdit !== null) {
        notaSpeseData.notaID = notaToEdit._id;
        fetchDispatch(notaSpeseData, true);
      } else {
        fetchDispatch(notaSpeseData);
      }
    }
  }


useEffect(() => {
  if (categories.length === 0 && !categorieLoading) {
    dispatch(getAllCategories());
  }
}, [categories.length, categorieLoading, dispatch]);

useEffect(() => {
  if (notaToEdit?.categoria && categories.length > 0) {
    const matchedCategory = categories.find(cat => cat._id === notaToEdit.categoria);
    if (matchedCategory) {
      setFormData(prevState => ({
        ...prevState,
        categoriaToShow: matchedCategory
      }));
    }
  }
}, [categories, notaToEdit]);

  const handleTipoChange = (nextTipo) => {
    setFormData((prevState) => ({
      ...prevState,
      tipo: nextTipo,
    }));
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      categoria: selectedOption ? selectedOption.value : '',
      categoriaToShow: selectedOption ? selectedOption : ''
      
    }));
    console.log(selectedOption, "selectedOption");
  };

  const fetchDispatch = async (notaSpeseData, isEdit = false) => {
    setisDisabled(true);
    try {
      let response;
      if (isEdit) {
        response = await dispatch(updateNotaSpese(notaSpeseData)).unwrap();
        toast.success("Nota spese modificata con successo!");
      } else {
        response = await dispatch(createNotaSpese(notaSpeseData)).unwrap();
        toast.success("Nota spese creata con successo!");
        // Update schedaSpese with new notaSpese
        const data = {
          notaSpeseData: response,
          schedaId: schedaId,
        };
        await dispatch(updateSchedaSpese(data)).unwrap();
      }
      if(scopeFromUrl === "shared") {
        await dispatch(getSharedSchedaSpese()).unwrap();
      } else {
        await dispatch(getPersonalSchedaSpese()).unwrap();
      }
    } catch (error) {
      console.error("Error Response:", error);
      toast.error(error.message || "Errore nella creazione della nota spese");
    } finally {
      onSuccess();
      setisDisabled(false);
    }
  };

  return (
    <Container>
      {/* {JSON.stringify(categories)} */}
      <Form className="mb-3" onSubmit={onSubmit}>

        <Form.Group className="mb-3">
          <Form.Label>Type</Form.Label>
          <NotaTipoField value={tipo} onChange={handleTipoChange} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Date</Form.Label>
          <Form.Control
            className="dashboard-input"
            type="date"
            id="inserimentoData"
            name="inserimentoData"
            value={inserimentoData}
            onChange={onChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Title</Form.Label>
          <Form.Control
            className="dashboard-input"
            type="text"
            id="testo"
            name="testo"
            value={testo}
            placeholder="Enter text"
            onChange={onChange}
            required
            maxLength={50}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount</Form.Label>
          <Form.Control
            className="dashboard-input"
            type="number"
            id="importo"
            name="importo"
            value={importo}
            placeholder="Enter amount"
            onChange={onChange}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3">
          {/* <Form.Label>Category</Form.Label> */}
          <Form.Control
            type="hidden"
            id="categoria"
            name="categoria"
            value={categoria}
            placeholder="Select a category"
            onChange={onChange}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Category</Form.Label>
          <SelectSearch
            value={formData.categoria}
            onChange={handleCategoryChange}
            option={categories.filter((cat) => !cat.hiddenForUser)}
            selected={categoriaToShow}
          />
        </Form.Group>

        <div className="row mt-4 mb-3">

          <div className="col-12">
            <button type="submit"
              className="d-flex align-items-center justify-content-center dashboard-btn-primary w-100"
              disabled={isDisabled}>
              <p className="mb-0 ">
                {notaToEdit === null ? ("Create") : ("Edit")}
              </p>
            </button>
          </div>
          <div className="col-12">
            {notaToEdit !== null &&
              <div
                style={{ cursor: "pointer" }}
                className='dashboard-btn-danger-outline w-100 mt-2'
                onClick={beforeDelete}>
                Delete
              </div>
            }
          </div>
        </div>
      </Form>

    </Container>
  )
}

export default NotaSpeseForm